import type { ThemeOptions } from '@mui/material';

export const linkComponent = {
  defaultProps: {
    underline: 'none',
  },
  styleOverrides: {
    root: {
      color: 'link',
    },
  },
} as const satisfies NonNullable<ThemeOptions['components']>['MuiLink'];
